/** English dictionary. Mirrors ru.ts key for key. */
export const en = {
  translation: {
    tabs: {
      today: 'Today',
      diary: 'Diary',
      add: 'Add',
      trends: 'Trends',
      profile: 'Profile',
    },
    today: {
      title: 'Today',
      ringTitle: 'Left today',
      kcalUnit: 'kcal',
      gramsShort: 'g',
      protein: 'Protein',
      fat: 'Fat',
      carbs: 'Carbs',
      activity: 'Activity',
      activityEmpty: 'No workouts yet',
      steps: 'steps',
      minShort: 'min',
      weight: 'Weight',
      weightAdd: 'Log weight',
      weightCaption: 'kg · {{delta}} over 7 days',
      habits: 'Habits',
      burnedNote: 'burned · estimate',
      habitWater: 'Water',
      habitSteps: 'Steps',
      habitStepsValue: '6.5k / 8k',
      habitWeigh: 'Weigh-in',
      habitNoSugar: 'No sugar',
      mockWorkoutTitle: 'Strength',
    },
    diary: {
      title: 'Diary',
      empty: 'Your day feed will appear here: meals, workouts, weight and habits in one timeline.',
    },
    add: {
      title: 'Add',
      hint: 'The camera will open here: a food photo is the most frequent entry.',
      chips: {
        workout: 'Workout',
        weight: 'Weight',
        habit: 'Habit',
        barcode: 'Barcode',
        text: 'Text',
      },
    },
    trends: {
      title: 'Trends',
      empty: 'Weight vs plan, average deficit, workouts and streaks — after your first week of data.',
    },
    profile: {
      title: 'Profile',
      plan: 'Plan & targets',
      planStub: 'Calorie and macro targets — calculated, editable',
      theme: 'Theme',
      themeDark: 'Dark',
      themeLight: 'Light',
      themeSystem: 'System',
      language: 'Language',
      account: 'Account',
      accountStub: 'E-mail sign-in; Apple and Google later',
    },
  },
} as const;
